
import { Button } from 'antd';
import GoogleIcon from "./svg/googleLogin";
import FaceBookIcon from "./svg/facebookLogin";
interface socialAuthProps {
    handleSocialAuth: (value: string) => void;
}
const SocialAuth: React.FC<socialAuthProps> = ({handleSocialAuth}) => {
    const handleSocialAuthentication = (value : string) => {
        handleSocialAuth(value);
    }
    return(
        <div  className="social-media-buttons icon-container socialMediaIcons-container">
        <Button  data-testid="googleIcon" className="social-media-btn" onClick={() =>handleSocialAuthentication("google")} >
            <GoogleIcon width={20} hanging={20} />
        </Button>
        <Button  data-testid="facebookIcon" className="social-media-btn" onClick={() =>handleSocialAuthentication("facebook")} >
            <FaceBookIcon width={20} hanging={20} />
        </Button>
    </div>
    )
}

export default SocialAuth;